import Dexie from 'dexie';

/**
 * IndexedDB Database Instance
 * Primary data source for offline functionality
 */
class OfflineDatabase extends Dexie {
  constructor() {
    super('BidzOfflineDB');
    
    this.version(1).stores({
      // PR Data - indexed by pr_token and pr_code for fast lookups
      purchaseRequests: '++id, pr_token, pr_code, lastSynced',
      
      // Master Data - indexed by their unique codes
      costCenters: '++id, costcenter_code, lastSynced',
      glCodes: '++id, gl_code, lastSynced',
      projectCodes: '++id, project_code, lastSynced',
      items: '++id, item_code, item_token, lastSynced',
      departments: '++id, name, lastSynced',
      vendors: '++id, token, lastSynced',
      users: '++id, token, lastSynced',
      prCodes: '++id, pr_code, lastSynced',
      
      // Offline Queue - indexed by timestamp for FIFO processing
      offlineQueue: '++id, timestamp, status, endpoint',
      
      // Generic Cache - key-value store for any API response
      cache: 'key, lastSynced',
    });
  }
}

// Singleton instance
export const db = new OfflineDatabase();

// Database initialization helper
export const initDatabase = async () => {
  try {
    await db.open();
    console.log('✅ IndexedDB initialized successfully');
  } catch (error) {
    console.error('❌ Failed to initialize IndexedDB:', error);
    throw error;
  }
};

// Clear all data (for testing/debugging)
export const clearAllData = async () => {
  try {
    await db.transaction('rw', db.tables, async () => {
      await Promise.all(db.tables.map(table => table.clear()));
    });
    console.log('✅ All IndexedDB data cleared');
  } catch (error) {
    console.error('❌ Failed to clear IndexedDB:', error);
    throw error;
  }
};

// Get database size (for monitoring)
export const getDatabaseSize = async () => {
  if ('storage' in navigator && 'estimate' in navigator.storage) {
    const estimate = await navigator.storage.estimate();
    return estimate.usage || 0;
  }
  return 0;
};
